import {DashboardType} from "../../../../../core/gd-modules/dashboard/model/dashboard/types";
import {projectProgressConfig} from "./project/project-progress";
import {projectAgileConfig} from "./project/project-agile";
import {projectSummaryConfig} from "./project/summary";
import {DashboardTemplateConfig} from "./templates-custom";

/*export type DashboardTemplateConfig = {
    templateId  : string,
    preview     : string,
    name        : string,
    description : string,
    className?  : string,
    dashboardType   : DashboardType,
    configFunction      : any
}*/

const emptyConfig = () => {}

export const dashboardTemplatesProject : DashboardTemplateConfig[] = [




    {
        templateId  : 'project-agile',
        name        : 'Sprint/Agile Dashboard',
        description : 'Real-time visibility into your sprint\'s progress and team performance.',
        preview     : 'agile-preview.svg',
        dashboardType   : DashboardType.PROJECT,
        configFunction  : projectAgileConfig
    },

    {
        templateId  : 'project-summary',
        name        : 'Project Summary',
        description : "Track project progress, milestones, performance and other key metrics.",
        preview     : 'project-summary-preview.svg',
        dashboardType   : DashboardType.PROJECT,
        configFunction  : projectSummaryConfig
    },

    {
        templateId  : 'project-progress',
        name        : 'Project Progress',
        description : 'Track and monitor project progress in real-time with actionable insights.',
        preview     : 'project-progress-preview.svg',
        dashboardType   : DashboardType.PROJECT,
        configFunction  : projectProgressConfig
    },

    {
        templateId      : 'project-empty',
        name            : 'Empty',
        dashboardTitle  : 'Dashboard',
        description     : 'Create a project dashboard from scratch.',
        preview         : 'add-custom-dashboard.svg',
        className       : 'add-dashboard',
        dashboardType   : DashboardType.PROJECT,
        configFunction  :emptyConfig
    },



]